export const logout = () => {
  localStorage.removeItem("autoload");
  window.location.href = "/";
}


// logout.ts (or LogoutComponent.tsx)

// import { useMutation } from "@tanstack/react-query";
// import { useNavigate } from "react-router-dom";
// import { useAtom } from "jotai";
// import { userData } from "../state/index";
// import api from "./api";
// import { notify } from "../customs/notification";

// // Logout API call
// const logout = async () => {
//   const user = JSON.parse(localStorage.getItem("autoload")!); // Get the access token from local storage
//   const token = user?.access_token;

//   return await api.post('/logout', {}, {
//     headers: {
//       Authorization: `Bearer ${token}`, // Attach the token
//     },
//   });
// };

// // Logout Handler Function
// export const useLogout = () => {
//   const [user, setUser] = useAtom(userData);
//   const navigate = useNavigate();

//   const logoutMutation = useMutation({
//     mutationFn: logout,
//     mutationKey: ["logout"],
//   });

//   const handleLogout = async () => {
//     try {
//       await logoutMutation.mutateAsync(undefined, {
//         onSuccess: () => {
//           // On success, clear user data and localStorage
//           setUser(undefined);
//           localStorage.removeItem("autoload");
//           navigate("/");  // Redirect to login page
//         },
//       });
//     } catch (error: any) {
//       const errorMessage = error?.response?.data?.error || "Logout failed";

//       notify({
//         message: "Error",
//         description: errorMessage,
//       });
//     }
//   };

//   return handleLogout;
// };
